import { CTABannerRefProjection } from '../references/CTABannerRef.query';

export const queryBlog = groq`*[_type == "blog" && currentPathname == $currentPathname][0]{
    ...,
  "blogHero": {
    title,
    "backgroundImg": heroImage,
    "date":articleDate,
    readTime,
    heroImage {
      asset-> {
        altText
      }
    },
    taxonomies[]->,
    person {
      reference->
    }
  },
  CTABanner {
    reference-> ${CTABannerRefProjection}
  }
}`;
